/* eslint-disable semi */
import app from './app';

/**
 * APIClientファクトリとしてexportする
 */
export default {
  app
};



// WEBPACK FOOTER //
// ./src/api/factories/index.js